<template>
    <div class="procedureAnnex" v-loading="loading">
        <div class="annexDataHeader">
            <nav>
                <div class="Route">
                    <a @click="backTop()">全部资料</a>
                    <template v-for="(item, index) in fileHierarchy">
                        <span :key="index" @click="returnDirectory(item.id, index, item)">
                            <i class="el-icon-arrow-right"></i>
                            {{ item.data }}
                        </span>
                    </template>
                </div>
            </nav>
            <div class="operationArea">
                <div class="fileBtn">
                    <el-tooltip class="item" effect="dark" content="上传" placement="bottom" v-if="!currentViewData.businessFileGroupConfig.IsRead && currentViewData.businessFileGroupConfig.IsAllowUpload">
                        <el-upload action="" class="upload_btn" :http-request="uploadFileMethod" :show-file-list="false" multiple>
                            <i class="iconfont iconshangchuan1"></i>
                        </el-upload>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="下载" placement="bottom">
                        <button class="iconfont iconxiazai2" @click="batchDownload"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="添加" placement="bottom" v-if="!currentViewData.businessFileGroupConfig.IsRead && currentViewData.businessFileGroupConfig.IsAllowCreateFolder">
                        <button class="iconfont icontianjia2" @click="isAdd = true"></button>
                    </el-tooltip>
                </div>
                <div class="plannedSpeed">
                    <el-progress color="#0078FB" define-back-color="#DBECFF" text-color="#0078FB" status="success" v-if="isProgress" :percentage="progressPercent"></el-progress>
                </div>
            </div>
        </div>
        <div class="annexList">
            <div class="AnnexInfo" id="AnnexInfoContainer" options="Setting">
                <table>
                    <thead v-if="isAdd">
                        <tr class="tebleFome">
                            <th style="width: 75px">
                                <svg class="iconwenjianjia1" aria-hidden="true">
                                    <use xlink:href="#iconwenjianjia1"></use>
                                </svg>
                            </th>
                            <td colspan="2">
                                <div>
                                    <input type="text" v-model="newFile.FileName" class="form-control" placeholder="请输入文件夹名称">
                                    <button class="el-icon-check" title="确认添加" @click="confirmAdd()"></button>
                                    <button class="el-icon-close" title="取消添加" @click="cancelAdd()"></button>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="fileData && fileData.length>0">
                            <tr v-for="(item, index) in fileData" :key="index" @click="seeFile(item)">
                                <th style="width: 75px">
                                    <svg v-if="item.FileType == 1" class="iconwenjianjia1" aria-hidden="true">
                                        <use xlink:href="#iconwenjianjia1"></use>
                                    </svg>
                                    <svg v-if="item.FileType == 0" class="iconwenjian" aria-hidden="true">
                                        <use xlink:href="#iconwenjian"></use>
                                    </svg>
                                </th>
                                <td>
                                    <h4 ref="content" class="fileName" :title="item.FileName" @click.stop="fileNameFocus($event)" @blur="preservationName($event, index, item)">
                                        {{ item.FileName }}
                                    </h4>
                                    <p class="fileTime">
                                        {{ item.CreateDate }}
                                    </p>
                                </td>
                                <td style="width: 150px">
                                    <div class="fileSize">
                                        <template v-if="item.FileType == 0">
                                            {{ bytesToSize(item.FileSize) }}
                                        </template>
                                    </div>
                                    <div class="fileBtns">
                                        <el-tooltip class="item" effect="dark" content="重命名" placement="top">
                                            <button v-if="buttonPermissions(item)" class="iconfont iconbianji" title="重命名" @click.stop="editFileClick(index, item)"></button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="上传" placement="top">
                                            <button title="上传" v-if="!currentViewData.businessFileGroupConfig.IsRead && currentViewData.businessFileGroupConfig.IsAllowUpload && item.FileType == 1" @click.stop="uploadClick(item)">
                                                <el-upload multiple action="" :show-file-list="false" :http-request="uploadFileMethod">
                                                    <i class="iconfont iconshangchuan1"></i>
                                                </el-upload>
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="下载" placement="top">
                                            <button v-if="item.FileType == 0" class="iconfont iconxiazai2" title="下载" @click.stop="download(item)"></button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="预览" placement="top">
                                            <button class="iconfont iconhetongchaxun" title="预览" @click.stop="viewFileClick(item)"></button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="删除文件" placement="top">
                                            <button
                                                v-if="buttonPermissions(item) && currentViewData.businessFileGroupConfig.IsAllowDeleteFile && item.FileType == 0"
                                                class="iconfont iconshanchu"
                                                title="删除文件"
                                                @click.stop="deleteFile_FileService(item)"
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="删除文件夹" placement="top">
                                            <button
                                                v-if="buttonPermissions(item) && currentViewData.businessFileGroupConfig.IsAllowDeleteFolder && item.FileType == 1"
                                                class="iconfont iconshanchu"
                                                title="删除文件夹"
                                                @click.stop="deleteFolderClick(item)"
                                            ></button>
                                        </el-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr class="noeAnnexData">
                                <td colspan="6">
                                    <p></p>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/css/annexStyle.styl';

export default {
    // 流程附件
    name: 'annex-data',
    components: {},
    props: {
        currentViewData: Object,
    },
    data() {
        return {
            fileGroupInstanceList: [],
            // 面包屑导航数据
            fileHierarchy: [],
            // 附件数据集合
            fileData: [],
            // 预览图片ID集合
            picturePreview: [],
            // 当前父ID 新增文件夹使用
            ParentID: 0,
            // 新增文件夹绑定数据
            newFile: {
                FileName: '',
                FileDescription: '',
            },
            filename: '',
            // 新增文件夹栏状态
            isAdd: false,
            // 当前父ID 上传附件使用，在文件夹上上传，和新增文件父id不一样
            currentFile: '0',
            // 在文件夹上上传,当前文件夹信息
            newFileinfo: {
                name: '',
                id: '',
            },
            // 上传文件加载中状态
            loading: false,
            // 文件上传进度条状态
            isProgress: false,
            // 文件上传进度
            progressPercent: 0,
            // 当前用户id
            Uid: this.$takeTokenParameters('Uid'),

            // aliyunOssToken: '',
        };
    },
    async created() {
        this.loading = true;
        this.Uid = this.$takeTokenParameters('Uid');
        this.gitAnnexData(this.currentViewData.businessInstanceId);
    },
    watch: {},
    methods: {
        // 获取附件数据
        gitAnnexData(businessInstanceId) {
            this.loading = true;
            this.$axios.get(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/${businessInstanceId}?&platformEnterprises=${this.currentViewData.platformEnterprises}`)
                .then(res => {
                    this.fileGroupInstanceList = res;
                    this.fileData = this.initFileData(res, this.currentFile);
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 文件大小转换
        bytesToSize(fileByte) {
            const fileSizeByte = fileByte;
            let fileSizeMsg = '';
            if (fileSizeByte < 1048576) {
                fileSizeMsg = (fileSizeByte / 1024).toFixed(1) + 'KB';
            } else if (fileSizeByte === 1048576) {
                fileSizeMsg = '1MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(1) + 'MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte === 1073741824) {
                fileSizeMsg = '1GB';
            } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(1) + 'GB';
            } else {
                fileSizeMsg = '文件超过1TB';
            }
            return fileSizeMsg;
        },
        // 根据id过滤附件数据
        initFileData(newVal, val, type) {
            const initFileData = [];
            if (newVal && newVal !== null) {
                newVal.forEach(item => {
                    if (item.ParentID === val) {
                        if (this.currentViewData.businessFileGroupConfig.IsModifyOwner) {
                            if (item.CreateId === this.$takeTokenParameters()) {
                                item.IsModifyOwner = true;
                            } else {
                                item.IsModifyOwner = false;
                            }
                        } else {
                            item.IsModifyOwner = true;
                        }
                        if (type === 'FileID' && item.FileType !== '1') {
                            initFileData.push(item.FileID);
                        } else {
                            initFileData.push(item);
                        }
                    }
                });
            }
            this.loading = false;
            return initFileData;
        },
        // 按钮权限
        buttonPermissions(data) {
            let isModifiable = false;
            if (this.currentViewData.businessFileGroupConfig.IsRead === false) {
                if (this.currentViewData.businessFileGroupConfig.IsModifyOwner === true) {
                    if (this.currentViewData.businessFileGroupConfig.IsModifyOwner && data.CreateId === this.Uid) {
                        isModifiable = true;
                    }
                } else if (this.currentViewData.businessFileGroupConfig.IsModifyOwner === false) {
                    isModifiable = true;
                }
            }
            return isModifiable;
        },
        // 重命名
        editFileClick(index, item) {
            if (item.FileType === '0') {
                this.renameVal = item.FileName.substring(0, item.FileName.lastIndexOf('.'));
                this.fileExtension = item.FileName.substr(item.FileName.lastIndexOf('.'));
            } else {
                this.renameVal = item.FileName;
                this.fileExtension = '';
            }
            this.$refs.content[index].contentEditable = true;
            this.$refs.content[index].innerText = this.renameVal;
            this.$refs.content[index].focus();
        },
        fileNameFocus(event) {
            event.stopPropagation();
        },
        // 失焦确定重命名
        preservationName(event, index, item) {
            this.$refs.content[index].contentEditable = false;
            const newFileName = this.$refs.content[index].innerText + this.fileExtension;
            this.$refs.content[index].innerText = newFileName;
            this.fileData[index].FileName = newFileName;
            this.$axios.put(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/filename?platformEnterprises=${this.currentViewData.platformEnterprises}`, {
                FileID: item.FileID,
                EditFileName: newFileName,
            }).then(res => {
                if (res) {
                    this.$message({
                        message: '更改成功！',
                        type: 'success',
                    });
                }
            }).catch(error => {
                this.$message.error(error.ErrorCode.Message);
            });
        },
        // 上传
        uploadClick(data) {
            this.currentFile = data.FileID;
            this.newFileinfo.name = data.FileName;
            this.newFileinfo.id = data.FileID;
        },
        // 文件下载
        download(data) {
            const downloadUrl = `${this.FILE.FILE_BASE_URL()}file-manage/${data.AFI_Code}/download`;
            this.$imagesDownload(downloadUrl, data.FileName);
        },
        // 批量下载
        batchDownload() {
            this.fileGroupInstanceList.forEach(async item => {
                if (item.FileType === '0') {
                    const downloadUrl = `${this.FILE.FILE_BASE_URL()}file-manage/${item.AFI_Code}/download`;
                    await this.$imagesDownload(downloadUrl, item.FileName);
                }
            });
        },
        //   预览
        viewFileClick(data) {
            this.picturePreview = [];
            if (data.FileType === '0' || data.FileType === 1) {
                this.picturePreview.push(data.AFI_Code);
            } else if (data.FileType === '1' || data.FileType === 1) {
                const row = this.fileGroupInstanceList.filter(item => item.ParentID === data.FileID);
                this.picturePreview = row.map(item => item.AFI_Code);
            }
            if (this.picturePreview.length > 0) {
                this.$toast({
                    title: true,
                    text: '预览',
                    type: 'eject',
                    width: '79%',
                    height: '88%',
                    t_url: 'picturePreview/index',
                    extr: {
                        code: {
                            imgSrc: [],
                            picturePreview: this.picturePreview,
                        },
                    },
                    viewPosition: 'components',
                });
            }
        },
        // 删除附件文件夹
        deleteFolderClick(item) {
            const deleteFileID = [];
            deleteFileID.push(...this.initFileData(this.fileGroupInstanceList, item.FileID));
            deleteFileID.forEach(item => {
                this.deleteFile_FileService(item);
            });
            this.deleteFile(item.FileID);
        },
        // 删除文件服务文件
        deleteFile_FileService(item) {
            const url = `${this.FILE.FILE_BASE_URL()}file-manage/${item.AFI_Code}`;
            this.$axios.delete(url, {})
                .then(() => {
                    this.deleteFile(item.FileID);
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 删除流程文件
        deleteFile(id) {
            this.$axios.delete(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/${id}?platformEnterprises=${this.currentViewData.platformEnterprises}`, {})
                .then(res => {
                    if (res) {
                        this.$message({
                            message: '删除成功！',
                            type: 'success',
                        });
                    }
                    this.fileGroupInstanceList.splice(this.fileGroupInstanceList.findIndex(v => v.FileID === id), 1);
                    this.fileData = this.initFileData(this.fileGroupInstanceList, this.currentFile);
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 确认添加
        confirmAdd() {
            if (this.newFile.FileName !== '') {
                this.$axios.post(`/interfaceApi/basicplatform/simpleflow/filegroupinstance?platformEnterprises=${this.currentViewData.platformEnterprises}`, {
                    FileID: '',
                    FileName: this.newFile.FileName,
                    FileExt: '',
                    FileSize: 0,
                    FileType: 1,
                    FileSort: 0,
                    FileDescription: this.newFile.FileDescription,
                    ParentID: this.ParentID,
                    BusinessType: '',
                    KeyID: this.currentViewData.businessInstanceId,
                    AFI_Code: '',
                }).then(res => {
                    this.fileGroupInstanceList.push(res);
                    this.fileData = this.initFileData(this.fileGroupInstanceList, this.currentFile);
                    this.newFile = {
                        FileName: '',
                        FileDescription: '',
                    };
                }).catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
                this.isAdd = false;
            } else {
                this.$message('请填写文件名称！');
            }
        },
        // 取消添加
        cancelAdd() {
            this.isAdd = false;
            this.newFile = {
                FileName: '',
                FileDescription: '',
            };
            this.filename = '';
        },
        // 查看
        seeFile(data) {
            if (data.FileType !== 0 && data.FileType !== '0') {
                this.ParentID = data.FileID;
                this.currentFile = data.FileID;
                const newFileData = [];
                (this.currentViewData.fileGroupInstanceList || []).forEach(item => {
                    if (item.ParentID === data.FileID) {
                        newFileData.push(item);
                    }
                });
                this.fileData = newFileData;
                this.fileHierarchy.push(
                    {
                        data: data.FileName,
                        id: data.FileID,
                        ...data,
                    }
                );
            }
        },
        // 返回顶层
        backTop() {
            this.fileData = this.initFileData(this.currentViewData.fileGroupInstanceList, '0');
            this.ParentID = '0';
            this.currentFile = '0';
            this.fileHierarchy = [];
        },
        // 返回上级目录
        returnDirectory(id, index, data) {
            this.ParentID = data.FileID;
            this.currentFile = data.FileID;
            this.fileData = this.initFileData(this.currentViewData.fileGroupInstanceList, id);
            this.fileHierarchy.splice(index + 1, this.fileHierarchy.length - index);
        },
        // 上传文件
        uploadFileMethod(param) {
            const tenantId = this.$takeTokenParameters('TenantId');
            const formData = new FormData();
            formData.append('FileType', 0);
            formData.append('BusinessTypeCode', 'Flow');
            formData.append('DataId', this.currentViewData.businessInstanceId);
            formData.append('DirectoryId', '');
            formData.append('TenantId', tenantId);
            formData.append('File', param.file);
            const config = {
                onUploadProgress: progressEvent => {
                    this.progressPercent = 0;
                    this.isProgress = true;
                    // progressEvent.loaded:已上传文件大小
                    // progressEvent.total:被上传文件的总大小
                    this.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2));
                },
            };
            const url = `${this.FILE.FILE_BASE_URL()}file-manage?__tenant=${tenantId}&platformEnterprises=${this.currentViewData.platformEnterprises}`;
            this.$axios.post(url, formData, config)
                .then(res => {
                    this.uploadFirm(res, param.file);
                }).catch(error => {
                    this.isProgress = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 上传成功，添加文件
        uploadFirm(res, fileData) {
            this.$axios.post(`/interfaceApi/basicplatform/simpleflow/filegroupinstance?platformEnterprises=${this.currentViewData.platformEnterprises}`, {
                FileID: '',
                FileName: fileData.name,
                FileExt: '',
                FileSize: fileData.size,
                FileType: 0,
                FileSort: 0,
                FileDescription: '',
                ParentID: this.currentFile,
                BusinessType: '',
                KeyID: this.currentViewData.businessInstanceId,
                AFI_Code: res.Id,
            }).then(res => {
                if (res) {
                    if (this.fileHierarchy.length === 0 || this.fileHierarchy[this.fileHierarchy.length - 1].id !== this.newFileinfo.id) {
                        this.fileHierarchy.push({
                            data: this.newFileinfo.name,
                            id: this.newFileinfo.id,
                        });
                    }
                    this.fileGroupInstanceList.push(res);
                    this.fileData = this.initFileData(this.fileGroupInstanceList, this.currentFile);
                    this.isProgress = false;
                }
            }).catch(error => {
                this.isProgress = false;
                this.$message.error(error.ErrorCode.Message);
            });
        },
    },
};
</script>

<style lang="stylus" >
.procedureAnnex
    height calc(100% - 42px)
    padding 0 !important
    .annexDataHeader
        height 84px
        background #FAFBFD
        nav
            padding 0 20px
            height 52px
            margin 0
            display flex
            align-items center
            a
                cursor: pointer;
                font-size 14px
                color #0078FB
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
            span
                font-size 14px
                color #999999
        .operationArea
            display flex
            justify-content space-between
            align-items center
            padding-left 20px
            background #F3F9FF
            .fileBtn
                display flex
                .upload_box
                    margin 0
                    width 40px
                button,.upload_btn
                    flex 0 0 40px
                    width 40px
                    height 28px
                    padding 0
                    line-height 28px
                    font-size 20px
                    color rgba(0, 0, 0, 0.5)
                    border none
                    background none
                    text-align center
                    i
                        font-size 22px
                        color rgba(0, 0, 0, 0.5)
            .plannedSpeed
                width calc(100% - 150px)
    .annexList
        height calc(100% - 84px)
        overflow-y auto
        table
            width 100%
            border-collapse collapse
            thead
                .tebleFome
                    th,td
                        height 50px
                    td
                        >div
                            display flex
                            input
                                width calc(100% - 100px)
                                height 36px
                                border 1px solid #D7D7D7
                                padding-left 14px
                            button
                                width 40px
                                margin-left 10px
                                border none
                                background none
                                font-size 20px
                                color rgba(0, 0, 0, 0.5)
            tr
                &.noeAnnexData
                    p
                        height 500px
                        background url(../images/noData.png) center no-repeat
                        background-size 80%
                &:not(.noeAnnexData)
                    border-bottom 1px solid #F0F0F0
                    &:hover
                        background #F7FAFD
                        .fileBtns
                            visibility visible
            th,td
                height 80px
            td
                &:last-child
                    padding-right 20px
            .iconwenjianjia1
                width 36px
                height 32px
                vertical-align -15px
                fill currentColor
                overflow hidden
            .iconwenjian
                width 32px
                height 40px
                vertical-align -15px
                fill currentColor
                overflow hidden
            .fileName
                width 200px
                overflow hidden
                white-space nowrap
                text-overflow ellipsis
                margin-bottom 5px
                font-size 16px
                height 36px
                line-height 36px
                color #333333
                &:focus,
                &:focus-visible
                    line-height 34px
                    border 1px solid #D7D7D7
                    padding-left 10px
            .fileTime,.fileSize
                font-size 12px
                line-height 18px
                color #999999
            .fileSize
                text-align right
                margin-bottom 10px
            .fileBtns
                visibility hidden
                display flex
                justify-content flex-end
                .upload_box
                    margin 0
                    width 35px
                button,.upload_btn
                    flex 0 0 35px
                    width 35px
                    height 28px
                    padding 0
                    line-height 28px
                    font-size 20px
                    color #666666
                    border none
                    background none
                    cursor pointer
                    i
                        font-size 22px
                    &:hover
                        color #0078FB
    .img_url
        width 100%
        height 100%
</style>
